import styled from 'styled-components';
import { border1 } from 'utils/style/colors';

interface IQuestionResponsesProps {
  disable: boolean;
  hidden?: boolean;
}

export const Error = styled('div')`
  color: red;
`;

export const QuestionResponses = styled('div')<IQuestionResponsesProps>`
  background: transparent;
  transition: all 0.7s ease;
  ${({ disable }) =>
    disable &&
    `
      opacity: 0.4;
      pointer-events: none;
  `}
  ${({ hidden }) =>
    hidden &&
    `
      display: none;
      pointer-events: none;
  `}
`;

export const FormActions = styled('div')`
  margin: 1em 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
`;

export const AutoCompleteAiStickyBar = styled.div`
  position: sticky;
  bottom: -17px;
  z-index: 5;
  display: flex;
  justify-content: stretch;
  align-items: stretch;
  width: 100%;
  padding: 1rem 0.75rem;
  margin-bottom: 0.5rem;
  background: var(--exact-white, #fff);
  border: ${border1};
  border-radius: 15px;
  box-sizing: border-box;
  overflow: visible;
`;

export const FormSubmit = styled.div`
  border-radius: 10px;
  padding: 20px;
  box-shadow: none;
  margin: 2em 0 3em;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  flex-wrap: wrap;
  border: ${border1};
`;

export const FormResponseProgress = styled('div')`
  border-radius: 10px;
  padding: 20px;
  box-shadow: none;
  margin: 2em 0 3em;
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  border: ${border1};
  gap: 0.75rem;

  & > div {
    width: 15rem;
    display: flex;
    gap: 0.25rem;
    align-items: center;
  }
`;

export const AddTitle = styled('div')`
  font-size: 15px;
  text-align: center;
  margin: auto;
  padding: 32px;
`;

export const RightSideSection = styled('div')`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const FormWrapper = styled('div')`
  max-width: 800px;
  width: 90%;
  margin: auto;
`;
